<template>
  <div>
    <div class="loginBg">
      <div class="loginDiv">
        <img alt="" :src="homeImg">
      </div>
      <div class="loginText">
        <p>上传自定义登录背景</p>
        <p>尺寸大小：1920X600像素（图片大小1M以内）</p>
        <p>仅支持JPG、 PNG图片文件</p>
        <p>此设置仅针对自定义网站域名生效，请在下方设置</p>
        <el-upload
          class="upload-demo"
          :action="url"
          accept = ".jpg,.png"
          :on-success="handleAvatarSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button size="small" type="primary">上传图片</el-button>
        </el-upload>
      </div>
    </div>
    <div class="textWd">
      <p style="font-weight: bold;">自定义网站域名要求：</p>
      <p>1) 必须具有通过实名认证的域名，如：xxx.com。</p>
      <p>2) 域名对应的官网（如：www.xxx.com）必须通过备案（根据《非经营性互联网信息服务备案管理办法》，网站需要完成备案或接入）。</p>
      <p>3) 配置您的xxx.com域名DNS解析，如：将iot.xxx.com映射为iot.juzi1688.cn配置如下：</p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="paltformTable">
        <tbody>
          <tr>
            <th>记录类型</th>
            <th>主机记录</th>
            <th>解析线路</th>
            <th>记录值</th>
            <th>MX优先级</th>
            <th>TTL</th>
          </tr>
          <tr>
            <td>CNAME</td>
            <td>H5</td>
            <td>默认</td>
            <td>iot.juzi1688.cn</td>
            <td>--</td>
            <td>10分钟</td>
          </tr>
        </tbody>
      </table>
      <p>4) iot.xxx.com映射为iot.juzi1688.cn配置如下：</p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="paltformTable">
        <tbody>
          <tr>
            <th>记录类型</th>
            <th>主机记录</th>
            <th>解析线路</th>
            <th>记录值</th>
            <th>MX优先级</th>
            <th>TTL</th>
          </tr>
          <tr>
            <td>CNAME</td>
            <td>H5</td>
            <td>默认</td>
            <td>iot.juzi1688.cn</td>
            <td>--</td>
            <td>10分钟</td>
          </tr>
        </tbody>
      </table>
      <p>5) iot.xxx.com映射为iot.juzi1688.cn配置如下</p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="paltformTable">
        <tbody>
          <tr>
            <th>记录类型</th>
            <th>主机记录</th>
            <th>解析线路</th>
            <th>记录值</th>
            <th>MX优先级</th>
            <th>TTL</th>
          </tr>
          <tr>
            <td>CNAME</td>
            <td>H5</td>
            <td>默认</td>
            <td>iot.juzi1688.cn</td>
            <td>--</td>
            <td>10分钟</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="paltform">
      <div>
        <p>配置管理平台简称（如：桔子智联）</p>
        <el-input v-model="queryParams.name" placeholder="桔子智联"></el-input>
      </div>
      <div>
        <p>配置管理平台URL域名（如：iot.xxx.com）</p>
        <el-input v-model="queryParams.platformDomain" placeholder="iot.juzi1688.cn"></el-input>
      </div>
      <div>
        <p>配置API接口URL域名（如：iot.xxx.com）</p>
        <el-input v-model="queryParams.apiDomain" placeholder="iot.juzi1688.cn"></el-input>
      </div>
      <div>
        <p>配置H5平台URL域名（如：iot.xxx.com）</p>
        <el-input v-model="queryParams.h5Domain" placeholder="iot.juzi1688.cn"></el-input>
        <span>配置后，请前往【公众号模板配置】中配置H5选项，从而保证H5地址显示为您自己的服务器。</span>
      </div>
    </div>
    <div class="saveBtn">
      <el-button size="small" type="primary" @click="submitBut">提交数据</el-button>
    </div>
  </div>
</template>
<script>
import { platformCustom } from "@/api/api.js";
import { getPlatformCustom } from "@/api/api.js";
export default {
  data() {
    return{
      userId:'',
      homeImg:"",
      url:"cms/file/upload/loginBg",
      queryParams:{
        name:"",
        h5Domain:"",
        apiDomain:"",
        platformDomain:""
      }
    }
  },
  methods: {
    handleAvatarSuccess(res){
      this.homeImg = "/cms/" + res.data.url;
    },
    initData(){
      let params = {
          userId : this.userId
      };
      getPlatformCustom(params).then(res =>{
        this.queryParams = res.data.data;
        this.homeImg = res.data.data.loginImgUrl;
      })
    },
    submitBut(){
      let params ={
        ...this.queryParams,
        userId : this.userId
      }
      params.loginImgUrl = this.homeImg
      platformCustom(params).then(res =>{
        if(res.data.code == 200){
          this.$notify({
            title: '成功',
            message: '信息提交成功',
            type: 'success'
          });
        }
      })
    }
  },
  created() {
    this.userId = this.$route.params && this.$route.params.userId;
    this.initData()
  },
  mounted() {
    
  },
};
</script>

<style scoped lang="less">
.loginBg{
  width: 100%;
  display: flex;
  .loginDiv{
    width: 300px;
    height: 170px;
    line-height: 170px;
    text-align: center;
    border: 1px solid #ddd;
    img{
      padding: 8px;
      width: 100%;
      height: 100%;
    }
  }
  .loginText{
    margin-left: 20px;
    p{
      color: #606266;
      font-size: 15px;
      padding: 2px 0;
    }
    .upload-demo{
      margin-top: 18px;
    }
  }
  .paltform{
    margin-left: 20px;
    .el-input{
      width: 300px;
      display: block;
      margin: 2px;
    }
  }
}
.textWd{
  margin-top: 20px;
  p{
    color: #606266;
    padding: 5px 0;
    font-size: 15px;
  }
  .paltformTable {
    width: 840px;
    background: #fff;
    font-size: 12px;
    margin-top: 5px;
    th{
      padding: 0 10px;
      border-bottom: 1px solid #ddd;
      height: 30px;
      line-height: 30px;
      font-weight: normal;
      color: #9a959c!important;
      text-align: left;
    }
    td{
      padding: 6px 10px;
      font-size: 14px;
      color: #2a2a2a;
      border-bottom: 1px solid #ddd;
    }
  }
}
.paltform{
  margin: 20px 0 80px 0;
  color: #606266;
  font-size: 14px;
  div{
    padding:10px 0;
    .el-input{
      width: 300px;
    }
    span{
      margin-left: 10px;
    }
  }
}
.saveBtn{
  background: #F8F8F8;
  padding: 15px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  margin-left: -50px;
  button{
    border-radius: 5px;
    font-size: 14px;
    width: 120px;
    height: 40px;
  }
}
</style>


